// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__pPkVu","content":"styles_content__2PdPO","selectAll":"styles_selectAll__1lHSf"};